import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useQuery, useMutation } from '@apollo/client'
import get from 'lodash/get'
import styled from 'styled-components'

import { ToggleButton, DECILE, HUNDRED, Spinner } from '@landscape/ui-lib'
import { selectUserDiCode, setModalOptions } from '@landscape/ui-redux'
import { GET_INSTITUTION_PREFERENCES, CREATE_INSTITUTION_PREFERENCE } from '@landscape/gql'

type ChartUnits = typeof DECILE | typeof HUNDRED

const ChartToggleSelection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 200px;
  height: 48px;
`

export const ChartPrefToggle: React.FC = () => {
  // const userDiCode = useSelector(selectUserDiCode)
  const dispatch = useDispatch()
  const [chartUnits, setChartUnits] = useState<ChartUnits>(DECILE)
  const [createInstitutionPreference] = useMutation(CREATE_INSTITUTION_PREFERENCE)
  const { _, loading } = useQuery(GET_INSTITUTION_PREFERENCES, {
    fetchPolicy: 'cache-and-network',
    onCompleted: (data) => {
      const values = get(data, 'getPreferenceByDiCode.values') || {}
      const { chartDisplayUnits } = values
      if (chartDisplayUnits) {
        setChartUnits(chartDisplayUnits)
      }
    },
  })

  const onChange = (choice) => {
    const confirmationModalOptions = {
      showModal: true,
      body: [
        `WARNING: Changing default charts view to "${choice}" will affect the view of ALL users at your institution`,
      ],
      status: 'warning',
      title: `Confirm Change`,
      primaryLabel: 'Confirm',
      cancelLabel: 'Cancel',
      confirm: true,
      handlerFunction: () => onConfirm(choice),
    }
    dispatch(setModalOptions(confirmationModalOptions))
  }

  const onConfirm = (choice) => {
    setChartUnits(choice)
    // update graphql value
    const variables = {
      input: {
        preferenceKey: 'chartDisplayUnits',
        preferenceValue: choice,
      },
    }
    createInstitutionPreference({ variables })
  }

  const toggleBtnProps = {
    selectedText: chartUnits,
    name: 'decile-hundred',
    onChange,
    buttonOneSelection: DECILE,
    buttonTwoSelection: HUNDRED,
  }

  return (
    <ChartToggleSelection>
      {loading ? (
        <Spinner size="xs" showSpinner={true} id="chart-units-sel" ariaLabel="Loading..." />
      ) : (
        <ToggleButton {...toggleBtnProps} />
      )}
    </ChartToggleSelection>
  )
}
